import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

export class EmergencyAreaPoints extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.emergencyAreaPointsShow(id)}>{value}</Link>,
            },
            {
                Header: "Адрес",
                accessor: "geozone",
                id: "geozone/address",
                filterable: true,
                sortKey: "geozone/address",
                Cell: ({ value }) => value.address,
            },
            {
                Header: "Комментарий",
                accessor: "comment",
                filterable: true,
            },
        ];
    }

    renderCreateButton = () => {
        const props = {
            className: "btn btn-brand btn-sm",
            to: paths.emergencyAreaPointsNew,
        };
        return <Link {...props}>{this.props.createBtnText}</Link>;
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(EmergencyAreaPoints, "emergency-area-points");
